import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import ProductSync from "./ProductSync";

const ProductSyncManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <ProductSync />} />
  </Switch>
);

export const ProductSyncManagement = withRouter(ProductSyncManagementRoutes);
